function Policies() {
  return (
    <div style={{ paddingRight: '1em', paddingLeft: '1em' }}>
      <p>
        <b>
          <u>IL EST PREALABLEMENT RAPPELE CE QUI SUIT :</u>
        </b>
      </p>

      <p>
        La société MAIA TRAVEL est une Société par actions simplifiée au capital
        social de 1 085 EUR, immatriculée au RCS de Reims sous le numéro 882 736 150,
        dont le siège social est situé 20, Rue du Petit Four – 51100 Reims (France).
      </p>

      <p>
        {' '}
        Le numéro de TVA intracommunautaire de la société MAIA TRAVEL est le FR
        16882736150.
      </p>
      <p>
        La société MAIA TRAVEL est propriétaire et éditrice d’une plateforme internet
        dénommée « MAIA TRAVEL », par le biais de laquelle des clients, agissant en
        qualité de consommateurs, ont notamment accès à des prestations de services
        touristiques.
      </p>
      <p>
        Cette plateforme est accessible <i>via</i> l’adresse :{' '}
        <a href='https://app.maia.travel'>https://app.maia.travel</a>.
      </p>
      <p>
        Dans ce cadre, par le biais du site internet « MAIA PARTNER », la société MAIA
        TRAVEL référence des prestataires, afin que ces derniers proposent leurs
        prestations de services touristiques auxdits particuliers, <i>via</i> la
        plateforme précitée.
      </p>
      <p>
        Les relations contractuelles de la société MAIA TRAVEL et desdits
        prestataires, sont régies par les présentes, ainsi que par les conditions
        générales d’utilisation du site « MAIA PARTNER. »{' '}
      </p>
      <p>
        <b>
          ARTICLE 1 : <u>DEFINITIONS</u>
        </b>
      </p>
      <p>
        Dans les présentes conditions générales de partenariat, les mots ou
        expressions commençant avec une majuscule auront la signification suivante :
      </p>
      <p>
        <b>Boutique :</b> désigne l’espace de vente de Prestations, hébergé sur le
        Site, géré et administré par le Prestataire.
      </p>
      <p>
        <b>CGP :</b> désigne le présent document et ses annexes éventuelles.
      </p>
      <p>
        <b>CGU :</b> désigne les conditions générales d’utilisation du Site,
        accessibles en ligne et acceptées par les Prestataires.
      </p>
      <p>
        <b>Partie(s) :</b> désigne(nt) individuellement la Société ou un Prestataire
        et collectivement la Société et un Prestataire.
      </p>
      <p>
        <b>Plateforme :</b> désigne la plateforme internet « MAIA TRAVEL » dont est
        propriétaire et éditrice la Société, accessible via l’adresse :{' '}
        <a href='https://app.maia.travel'>https://app.maia.travel</a>.
      </p>
      <p>
        <b>Prestataires :</b> désigne les Prestataires référencés sur la Plateforme,
        afin que ces derniers proposent leurs prestations de services touristiques aux
        clients, agissant en qualité de consommateurs.
      </p>
      <p>
        <b>Prestations :</b> désignent les prestations de services touristiques
        proposées à la commande en ligne aux clients, agissant en qualité de
        consommateurs, par les Prestataires, par le biais de la Plateforme.
      </p>
      <p>
        <b>Prestations interdites :</b> désignent les prestations contraires aux
        bonnes mœurs ou non autorisés à la vente par des dispositions législatives ou
        réglementaire. Ainsi, sont interdites à la vente en ligne sur la Plateforme
        les prestations suivantes (cette liste n’est pas exhaustive) : les prestations
        portant atteinte à des droits de propriété intellectuelle ou industrielle ou
        aux droits de la personnalité d’un tiers ; les prestations faisant l’objet
        d’une commercialisation dans le cadre d’un réseau de distribution exclusive ou
        sélective et pour lesquels le Prestataire n’a pas obtenu d’agrément ; les
        prestations à caractère pornographique et plus généralement portant atteinte
        aux bonnes mœurs ; les prestations incitant à la haine raciale ou constituant
        une base de discrimination fondée sur la race, le sexe, la religion, la
        nationalité, les capacités physiques, l’orientation sexuelle ou l’âge.
      </p>
      <p>
        <b>Société :</b> désigne la société MAIA TRAVEL.
      </p>
      <p>
        <b>Plateforme :</b> désigne la plateforme internet « MAIA TRAVEL » dont est
        propriétaire et éditrice la Société, accessible <i>via</i> l’adresse :{' '}
        <a href='https://app.maia.travel'>https://app.maia.travel</a>.
      </p>
      <p>
        <b>
          ARTICLE 2 : <u>OBJET</u>
        </b>
      </p>
      <p>
        Les présentes CGP ont notamment pour objet de décrire leur champ
        d’application.
      </p>
      <p>
        Elles traitent également : (i) des relations entre les Parties ; (ii) des
        conditions de référencement des Prestataires et de leurs prestations sur la
        Plateforme ; (ii) des conditions de commande desdites prestataires (rôle
        d’intermédiaire de la Société ; respect de la réglementation applicable par le
        Prestataire ; réservation ; annulation ; tarification et paiement) ; (iii) des
        conditions de facturation, d’encaissement et financières.
      </p>
      <p>
        Elles traitent aussi des responsabilités respectives de la Société et des
        Prestataires.
      </p>
      <p>
        <b>
          ARTICLE 3 – <u>CHAMP D’APPLICATION</u>
        </b>
      </p>
      <p>
        Les présentes CGP s’appliquent de plein droit aux relations contractuelles
        entre les Parties.
      </p>
      <p>
        Tout référencement d’un Prestataire sur la Plateforme, afin d’y proposer ses
        prestations, implique l’adhésion préalable expresse et sans réserve du
        Prestataire concerné aux présentes CGP, lesquelles prévalent sur toutes autres
        conditions, sauf accord contraire écrit et préalable entre les Parties.
      </p>
      <p>
        <b>
          ARTICLE 4 – <u>RELATION ENTRE LES PARTIES</u>
        </b>
      </p>
      <p>
        <b>4.1. Indépendance réciproque</b>
      </p>
      <p>
        Chacune des Parties est un contractant indépendant et aucune des Parties
        n’exercera de contrôle sur la conduite de l’activité de l’autre Partie au
        titre des présentes CGP.
      </p>
      <p>
        Aucune des dispositions des présentes ne sera réputée créer une relation
        d’employeur à salarié entre les Parties, et chacune des Parties ne répondra à
        tous égards, que de l’emploi, du contrôle et de la conduite de toutes les
        personnes employées par elle.
      </p>
      <p>
        Aucune des Parties ni aucun de ses salariés n’est autorisée à engager, ni ne
        peut se déclarer autorisée à engager l’autre Partie à quelque titre que ce
        soit.
      </p>
      <p>
        <b>4.2. Exclusion de qualification</b>
      </p>
      <p>
        Les Parties déclarent que les présentes ne saurait s’analyser en un mandat
        d’intérêt commun.
      </p>
      <p>
        <b>4.3. Absence d’exclusivité</b>
      </p>
      <p>Les Parties ne se réservent aucune exclusivité.</p>
      <p>
        <b>
          ARTICLE 5 – <u>REFERENCEMENT D’UN PRESTATAIRE SUR LA PLATEFORME</u>
        </b>
      </p>
      <p>
        <b>5.1. Création d’un compte</b>
      </p>
      <p>
        Seuls les Prestataires disposant d’un compte personnel sur le Site, ont la
        possibilité de proposer des Prestations sur la Plateforme, commandées par des
        clients, agissant en qualité de consommateur ; lesquels disposent eux-mêmes
        d’un compte personnel sur ladite Plateforme.
      </p>
      <p>
        L’inscription sur le Site se fait par la création d’un compte personnel, en
        suivant les indications prévues à cet effet sur le Site.
      </p>
      <p>
        Notamment, le Prestataire communique les informations suivantes à la Société :
        identifiants (email et mot de passe) ; identité (prénom ; nom ; numéro de
        téléphone) ; entreprise (numéro SIREN ; raison sociale ; adresse postale ;
        catégorie ; sous-catégorie ; activité).
      </p>
      <p>
        Il doit également accepter les CGU, en cochant la case prévue à cet effet en
        fin du formulaire précité.
      </p>
      <p>
        Les informations saisies sont transmises à la Société pour validation de la
        création du compte personnel du Prestataire.
      </p>
      <p>Cette validation est effectuée sous 24h maximum.</p>
      <p>
        La Société se réserve le droit de ne pas valider l’ouverture d’un compte, sans
        avoir à s’en justifier.
      </p>
      <p>
        Une fois les informations validées, la Société débloque le compte personnel du
        Prestataire sur le Site et lui adresse un email de validation, afin qu’il
        confirme son inscription.
      </p>
      <p>
        Lorsqu’il sollicite l’ouverture d’un compte personnel sur le Site, le
        Prestataire garantit notamment qu’il est majeur et qu’il dispose de la pleine
        capacité juridique pour conclure un contrat.
      </p>
      <p>
        <b>5.2. Gestion de sa Boutique</b>
      </p>
      <p>
        Au travers du Site et de la Plateforme, la Société permet au Prestataire de
        proposer des prestations de services touristiques, à des clients, agissant en
        qualité de consommateurs et utilisant ladite Plateforme.
      </p>
      <p>
        <b>5.3. Autres services</b>
      </p>
      <p>
        Au-delà de ce service, le Site propose des fonctionnalités complémentaires aux
        Prestataires.
      </p>
      <p>
        Ainsi, ils disposent notamment d’un tableaux de bord de leur chiffre
        d’affaires généré depuis la Plateforme sur une période sélectionnée, ainsi que
        des pages relatives : aux services touristiques qu’ils proposent ; aux clients
        effectués des commandes ; à leur agenda ; aux paramètres de leur Boutique ; à
        l’assistance ; à une messagerie.
      </p>
      <p>
        <b>5.4. Obligations en matière de conditions de travail</b>
      </p>
      <p>
        La Société fait preuve d’une extrême vigilance dans le choix de ses
        partenaires et s’assure, avant tout référencement sur le Site et la
        Plateforme, du respect par les Prestataires de la réglementation sociale.
      </p>
      <p>
        A ce titre, le Prestataire déclare être en règle en matière de législation
        sociale et plus particulièrement vis-à-vis des dispositions concernant le
        travail dissimulé et le démarchage. Il garantit la Société contre tout recours
        à ce sujet.
      </p>
      <p>
        En exécution des articles R. 324-4 et suivants du Code du Travail, le
        Prestataire s’engage à transmettre tous les six (6) mois à la Société, les
        documents suivants : (i) une attestation de fourniture de déclaration sociale
        transmise par l’URSSAF et datant de moins de six (6) mois ; (ii) une
        attestation fiscale émise par le centre des impôts dont dépend le Prestataire,
        certifiant qu’il a souscrit les déclarations fiscales lui incombant et datant
        de moins de six (6) mois ; (iii) un extrait KBIS datant de moins de six (6)
        mois.
      </p>
      <p>
        La Société demande au Prestataire l’engagement de respecter toutes les
        règlementations sociales en vigueur, ainsi que toutes les règles relatives aux
        Droits de l’Homme.
      </p>
      <p>
        <b>5.5. Taxes et droits</b>
      </p>
      <p>
        La Société fait preuve d’une extrême vigilance dans le choix de ses
        partenaires et s’assure, avant tout référencement sur la Plateforme, du
        respect par les Prestataires de la réglementation fiscale.
      </p>
      <p>
        A ce titre, la Société rappelle au Prestataire qu’il demeure intégralement
        responsable : de la collecte et du paiement de toute taxe et impôt ; du
        paiement de toute taxe, redevance ou rémunération afférents aux
        téléconsultations effectuées.
      </p>
      <p>
        <b>ARTICLE 6 – PRESTATIONS</b>
      </p>
      <p>
        <b>6.1. Référencement</b>
      </p>
      <p>
        Le référencement d’une Prestation se fait par le Prestataire, au travers de sa
        Boutique, en suivant les indications prévues à cet effet sur le Site.
      </p>
      <p>
        Avant d’être publiée sur la Plateforme, toute Prestation référencée par le
        Prestataire, doit être validée par la Société. La Société se réserve le droit
        de ne pas valider le référencement d’une Prestation, sans avoir à s’en
        justifier.
      </p>
      <p>
        Par ailleurs, le Prestataire s’engage à ne pas proposer des Prestations
        interdites. En cas de non-respect de cette obligation, le Prestataire pourra
        être exclu du Site et de la Plateforme, dans les conditions définies à
        l’Article 14.2 des présentes.
      </p>
      <p>
        <b>6.2. Détermination du prix de vente des Prestations</b>
      </p>
      <p>
        Le Prestataire est libre de déterminer les prix de vente des Prestations sur
        la Plateforme, mais s’engage à ce que ces prix ne soient pas supérieurs aux
        prix affichés sur son propre site internet.
      </p>
      <p>
        En cas de non-respect de cette obligation, la Société mettra les Prestations
        concernées hors ligne, afin que le Prestataire régularise la situation dans un
        délai de vingt-quatre (24) heures. A défaut, l’ensemble des Prestations du
        Prestataire pourra être retiré de la Plateforme.
      </p>
      <p>
        <b>ARTICLE 7 – PROCESSUS DE VENTE</b>
      </p>
      <p>
        <b>7.1. Rôle d’intermédiaire de la Société</b>
      </p>
      <p>
        La Société met à disposition du Prestataire un service de mise en relation
        avec des clients, agissant en qualité de consommateurs, afin que ces derniers
        commandent en ligne des Prestations, <i>via</i> la Plateforme.
      </p>
      <p>
        Ainsi, elle n’est pas responsable ni des informations précontractuelles
        fournies par le Prestataire, ni de l’exécution qu’il fait dudit contrat.
      </p>
      <p>
        En d’autres termes, le Prestataire reconnaît qu’il est seul responsable de
        ladite exécution.
      </p>
      <p>
        Dans ce contexte, le Prestataire s’oblige à ne créer aucune ambiguïté sur son
        identité et/ou son indépendance vis-à-vis de la Société, en particulier dans
        le cadre de ses communications destinées notamment auxdits clients,
        partenaires ou autorités.
      </p>
      <p>
        <b>7.2. Respect de la réglementation applicable par le Prestataire</b>
      </p>
      <p>
        Le Prestataire s’engage à respecter l’ensemble de la règlementation applicable
        à son domaine d’activité.
      </p>
      <p>
        En cas de non-respect de cette obligation, le Prestataire pourra être exclu du
        Site et de la Plateforme, dans les conditions définies à l’Article 14.2 des
        présentes.
      </p>
      <p>
        <b>7.3. Modalités de commande d’une Prestation</b>
      </p>
      <p>
        Seuls les clients, agissant en qualité de consommateurs, disposant d’un compte
        personnel sur la Plateforme ont la possibilité de commander une Prestation,
        selon les modalités de commande suivantes.
      </p>
      <p>
        <b>7.4. Prix et paiement</b>
      </p>
      <p>Les prix des Prestations sont fixes et sont indiqués sur la Plateforme.</p>
      <p>Il s'agit de prix forfaitaires, TTC, définitifs et non révisables.</p>
      <p>
        Le paiement de toute Prestation est effectué par carte bancaire sur la
        Plateforme de la Société, au moyen d’un service de paiement sécurisé
        (MangoPay).
      </p>
      <p>
        <b>7.5. Conditions générales de prestation de services des Prestataires</b>
      </p>
      <p>
        <b>
          ARTICLE 8 – <u>TRAITEMENT DES COMMANDES</u>
        </b>
      </p>
      <p>
        <b>
          ARTICLE 9 – <u>FACTURATION</u>
        </b>
      </p>
      <p>
        La Société dispose d’un mandat pour facturer les Prestations commandées auprès
        des Prestataires, à leur nom et pour leur compte.
      </p>
      <p>
        Les factures des Prestataires sont donc émises par la Société. Elles sont
        ensuite communiquées aux clients, agissant en qualité de consommateur,{' '}
        <i>via</i> la Plateforme et aux Prestataires, <i>via</i> le Site.
      </p>
      <p>
        Les Prestataires se réservent le droit de refuser ou d'annuler toute commande
        d'un client, notamment en cas d'insolvabilité dudit client ou dans l'hypothèse
        d'un défaut de paiement de la commande concernée ou d'un litige relatif au
        paiement d'une commande antérieure.
      </p>
      <p>
        <b>
          ARTICLE 10 – <u>ENCAISSEMENT</u>
        </b>
      </p>
      <p>
        Les fonds relatifs à une commande sont placés sur le « <i>e-wallet</i> » du
        Prestataire au sein de MangoPay (établissement bancaire choisi par la Société)
        et il pourra les transférer vers son compte bancaire référencé, dans les
        conditions prévues aux conditions générales d’utilisation de MangoPay
        (lesquelles sont accessibles via le « <i>footer</i> » du Site).
      </p>
      <p>
        <b>
          ARTICLE 11 – <u>CONDITIONS FINANCIERES</u>
        </b>
      </p>
      <p>
        En contrepartie de la mise en relation avec des clients et des services
        auxquels il a accès, le Prestataire s’engage à verser à la Société, un
        pourcentage de 15% du chiffre d’affaires T.T.C qu’il réalise au titre de la
        vente de Prestations via la Plateforme.
      </p>
      <p>
        Ces commissions sont directement prélevées par MangoPay, au moment de chaque
        paiement d’une commande par un clients, dans les conditions prévues aux
        conditions générales d’utilisation de MangoPay (lesquelles sont accessibles
        via le « <i>footer</i> » du Site).
      </p>
      <p>
        Avant le 5 de chaque mois, la Société adresse au Prestataire une facture
        relative aux commissions prélevées le mois précédent.
      </p>
      <p>
        <b>
          ARTICLE 12 – <u>RESPONSABILITE</u>
        </b>
      </p>
      <p>
        <b>12.1. Responsabilité du Prestataire</b>
      </p>
      <p>
        Le Prestataire reconnaît être seul responsable des Prestations qu’il propose
        et vend. Par conséquent, la Société ne pourra pas être tenue responsable en
        cas de préjudice subi par lui-même, l’acheteur ou toute personne tierce, du
        fait du contenu de ses offres de Prestations, des prix affichés et de
        l’exécution ou inexécution des ventes de Prestations. Le Prestataire l’en
        relève et garantit.
      </p>
      <p>
        Le Prestataire garantit la Société, ainsi que ses dirigeants et préposés
        contre toute action judiciaire ou administrative dont elle ferait l’objet,
        ainsi que contre tout préjudice, y compris un préjudice de perte de revenus,
        d’atteinte à l’image ou un préjudice moral, qu’elle subirait et qui
        résulterait en tout ou en partie de la violation des obligations légales ou
        contractuelles du Prestataire et de ses déclarations et garanties, notamment
        au titre des présentes.
      </p>
      <p>
        En cas de procédure contentieuse engagée par un client à l’encontre de la
        Société et relative à une commande passée <i>via</i> la Plateforme, le
        Prestataire s’oblige à intervenir spontanément en la cause.
      </p>
      <p>
        Par ailleurs, la Société se réserve la possibilité de réclamer des dommages et
        intérêts si, en raison d’une exécution insatisfaisante du contrat conclu entre
        le Prestataire et un client, la Société supportait la charge d’une
        indemnisation dudit client.
      </p>
      <p>
        <b>12.2. Responsabilité de la Société</b>
      </p>
      <p>
        La Société ne saurait être responsable que des dommages directs qu’elle aurait
        causé à l’autre Partie par sa faute, dont la preuve doit être rapportée par
        ladite autre Partie.
      </p>
      <p>
        La Société ne saurait être tenue responsable d’aucun dommage indirect subi par
        l’autre Partie. Notamment, les Parties conviennent qu’est considéré comme un
        dommage indirect tout préjudice financier ou commercial, toute perte de
        chiffre d’affaires, de bénéfice, de données, de clientèle.
      </p>
      <p>
        En tout état de cause, le montant maximum d’indemnisation ne pourra dépasser
        le montant annuel de commission versée à la Société.
      </p>
      <p>
        <b>12.3. Prescription</b>
      </p>
      <p>
        Conformément aux dispositions de l’article 2254 du Code civil, toute action en
        justice d’une des Parties à l’égard de l’autre Partie est frappée de
        prescription à l’expiration d’une durée d’un an courant à compter de la date à
        laquelle la Partie demanderesse concernée a eu connaissance ou est présumée
        avoir eu connaissance du fait dommageable.
      </p>
      <p>
        <b>
          ARTICLE 13 – <u>ASSURANCE</u>
        </b>
      </p>
      <p>
        Le Prestataire certifie avoir souscrit une police d’assurance auprès d’une
        compagnie d’assurance notoirement solvable et établie en France pour toutes
        les conséquences pécuniaires au titre de sa responsabilité civile,
        professionnelle, délictuelle et/ou contractuelle, et celle de ses dirigeants
        et préposés, pour tous les dommages qui pourraient être causés aux clients, à
        la Société et/ou aux tiers.
      </p>
      <p>
        Il remettra à la Société, à première demande, une attestation de sa compagnie
        d’assurance ou de son coutier indiquant notamment les risques couverts, les
        seuils et les plafonds de garantie.
      </p>
      <p>
        <b>
          ARTICLE 14 – <u>DUREE</u>
        </b>
      </p>
      <p>
        <b>14.1. Durée et résiliation</b>
      </p>
      <p>
        Les présentes sont conclues pour une durée indéterminée, à compter de leur
        acceptation, dans les conditions définies à l’Article 5.1 des présentes.
      </p>
      <p>
        L’un ou l’autre des Parties pourra résilier les présentes par lettre
        recommandée avec accusé de réception, moyennant le respect d’un délai de
        préavis raisonnable.
      </p>
      <p>
        <b>14.2. Suspension</b>
      </p>
      <p>
        Si le Prestataire ne respecte pas l’une des obligations légales ou
        contractuelles, la Société sera en droit de suspendre de manière temporaire ou
        définitive son référencement sur le Site et la Plateforme. Cette suspension
        s’exercerait sans préavis et sans indemnité.
      </p>
      <p>
        <b>
          ARTICLE 15 – <u>RESILIATION</u>
        </b>
      </p>
      <p>15.1. Force majeure</p>
      <p>
        En cas de survenance d’un événement de force majeure au sens de l’article 1218
        du Code civil, y compris, mais sans y être limités, des évènements
        imprévisibles tels que des grèves, arrêts de travail, troubles sociaux,
        fermetures d’usines, inondations, incendies, défauts de production ou de
        transports non-consécutifs à son fait personnel, ruptures d’approvisionnement,
        guerres, émeutes, insurrections, et plus généralement toute circonstance ou
        événement empêchant la Société et/ou le Prestataire d’exécuter convenablement
        ses/leurs obligations, la Société/le Prestataire ne sera pas responsable d’un
        éventuel défaut d’exécution de ses obligations, sous réserve d’en avoir
        informé immédiatement l’autre Partie et d’avoir pris toutes les mesures
        nécessaires pour en limiter les effets.
      </p>
      <p>
        Dans le cas où les effets d’un événement de force majeure se prolongerait
        au-delà de quatre-vingt-dix (90) jours, les Parties pourront résilier les
        présentes par lettre recommandée avec accusé de réception.
      </p>
      <p>
        <b>15.2. Inexécution</b>
      </p>
      <p>
        En cas d'inexécution de l'une quelconque de ses obligations essentielles par
        le Prestataire, les présentes pourront être résiliées par la Société, au moyen
        d’une lettre recommandée avec accusé de réception, huit (8) jours après mise
        en demeure restée infructueuse, et sans préjudice de toute action en dommages
        et intérêts.
      </p>
      <p>
        <b>
          ARTICLE 16 – <i>INTUITU PERSONAE</i> – INCESSIBILITE
        </b>
      </p>
      <p>
        Il est expressément convenu entre les Parties que leur accord au titre des
        présentes est conclu « <i>intuitu personae</i>. »
      </p>
      <p>
        En conséquence, les Parties ne peuvent céder, transférer ou apporter, à titre
        onéreux ou gratuit, les droits et obligations que leur confère l’accord au
        titre des présentes, sauf accord préalable écrit de l’autre Partie. Le
        non-respect de ces dispositions autorise l’autre Partie à résilier les
        présentes.
      </p>
      <p>
        <b>ARTICLE 17 – CONFIDENTIALITE</b>
      </p>
      <p>
        <b>17.1.</b>
      </p>
      <p>
        Les informations confidentielles (ci-après désignées les «{' '}
        <b>
          <i>Informations confidentielles</i>
        </b>{' '}
        ») comprennent notamment toute information, connaissance ou données de nature
        intellectuelle, technique, scientifique, financière, économique ou commerciale
        communiquées échangées entre les Parties, dans le cadre de l’exécution des
        présentes, sous quelque forme que ce soit.
      </p>
      <p>
        Il est entendu que les Informations confidentielles comprennent également
        toutes celles éventuellement déjà échangées entre les Parties, avant
        l’acceptation des présentes.
      </p>
      <p>
        <b>17.2.</b>
      </p>
      <p>
        Les Parties s'engagent l’une envers l’autre, aussi bien pendant la durée
        d’exécution des présentes, que dans un délai de cinq (5) ans après son terme à
        respecter la confidentialité des Informations confidentielles qu’elles auront
        échangées et s’interdisent de les communiquer aux personnes autres que celles,
        qui en vertu de la loi, ont qualité pour en connaître, la Partie concernée
        devant néanmoins, dans ce dernier cas, en avoir été informée préalablement et
        suffisamment à l'avance.
      </p>
      <p>
        Les Parties s'engagent l’une envers l’autre à n’utiliser ces Informations
        confidentielles que dans le cadre de l’exécution des présentes.
      </p>
      <p>
        Les Parties s'engagent l’une envers l’autre à faire respecter cette obligation
        par les intervenants de quelque nature qu'ils soient, permanents ou
        occasionnels, ainsi que par les personnes avec lesquelles elles partagent
        leurs bureaux, qui pourraient en avoir connaissance à l'occasion de
        l'exécution des présentes.
      </p>
      <p>
        À tout moment et au plus tard au terme des présentes, l’ensemble des
        Informations confidentielles échangées entre les Parties sur tout support et
        leurs copies autorisées seront retournés à chacune des Parties.
      </p>
      <p>
        <b>17.3.</b>
      </p>
      <p>
        Les obligations de confidentialité et limites d’usage susmentionnées ne
        s’appliqueront pas aux informations dont l’une des Partie pourrait prouver :
      </p>
      <ul type='none'>
        <p>
          <li>
            - qu’elles ont été connues par elle avant leur communisation par l’autre
            Partie ;
          </li>
        </p>
        <p>
          <li>
            - qu’elles étaient ou sont devenus connues du public sans infraction des
            présentes ;
          </li>
        </p>
        <p>
          <li>
            - qu’elles ont été communiquées et/ou ont été mises à la disposition de
            ladite Partie par un tiers, sans restriction, ni confidentialité.
          </li>
        </p>
      </ul>
      <p>
        <b>ARTICLE 18 – PROPRIETE INTELLECTUELLE</b>
      </p>
      <p>
        <b>18.1. Informations confidentielles</b>
      </p>
      <p>
        Les Parties reconnaissent que l’ensemble des Informations confidentielles
        échangées entre-elles aux fins d’exécution des présentes sont couvertes par
        des droits de propriété intellectuelle.
      </p>
      <p>
        En aucun cas, les présentes ne sauraient emporter une quelconque cession de
        droits ou autorisation d’utiliser ou de diffuser tout ou partie de ces
        Informations confidentielles de l’une des Partie au profit de l’autre Partie.
      </p>
      <p>
        <b>18.2. Site et Plateforme</b>
      </p>
      <p>
        Les droits d’auteur et autres droits de propriété intellectuelle de quelque
        nature qu’ils soient, liés au Site et à la Plateforme, sont et demeurent la
        propriété de la Société. Dans ce contexte, le Prestataire s’engage à ne pas
        utiliser ou reproduire le Site et la Plateforme, pour quelques raisons que ce
        soit, autre que celles prévues aux présentes.
      </p>
      <p>
        <b>ARTICLE 19 – DIVERS</b>
      </p>
      <p>
        <b>19.1. Indivisibilité et intégralité</b>
      </p>
      <p>
        De convention expresse entre les Parties, tous les documents annexés aux
        présentes, et signés par les Parties, sont considérés comme formant un
        ensemble indivisible et indissociable de ce dernier.
      </p>
      <p>
        Les Parties reconnaissent que les présentes constituent l’intégralité des
        accords passés entre elles relatifs à leur objet et remplacent tous les
        engagements antérieurs, verbaux et/ou écrits, passés entre les Parties,
        relatifs à l’objet des présentes. Les présentent prévalent ainsi sur tout
        autre document.
      </p>
      <p>
        Sauf stipulation expresse contraire, les termes et conditions et obligations
        du présent document prévaudront sur tous autres.
      </p>
      <p>
        <b>19.2. Modifications</b>
      </p>
      <p>
        Les présentes ne pourront être modifiées que d’un commun accord entre les
        Parties, par voie d’avenants.
      </p>
      <p>
        <b>19.3. Nullité</b>
      </p>
      <p>
        La nullité, l'inopposabilité, ou plus généralement, l'absence d'effet de l'une
        quelconque des stipulations des présentes n'affectera pas les autres
        stipulations qui demeureront parfaitement valables et contraignantes.
      </p>
      <p>
        En outre, les Parties conviennent de remplacer dans la mesure du possible,
        toute stipulation privée d'effet, par une stipulation valide ayant le même
        effet et reflétant leur volonté initiale.
      </p>
      <p>
        Faute d'y parvenir, la stipulation privée d'effet sera considérée comme
        n'ayant jamais existé.
      </p>
      <p>
        <b>19.4. Non renonciation</b>
      </p>
      <p>
        Le fait pour l’une des Parties de ne pas se prévaloir d’un manquement par
        l’autre Partie à l’une quelconque des obligations visées aux présentes, ne
        saurait être interprétée pour l’avenir comme une renonciation à l’obligation
        en cause.
      </p>
      <p>
        <b>ARTICLE 20 – DROIT APPLICABLE ET CLAUSE ATTRIBUTIVE DE JURIDICTION</b>
      </p>
      <p>Les présentes sont soumises au droit français.</p>
      <p>
        Le Tribunal de Commerce de Reims sera seul compétent pour connaître des
        contestations relatives aux présentes.
      </p>
      <p>
        <b>ARTICLE 21 – VERSIONS FRANCAISE ET ETRANGERE</b>
      </p>
      <p>
        Les présentes sont rédigées en français. En cas de contradiction ou de
        contresens, elles prévaudront sur toute autre version qui serait rédigée dans
        une autre langue à la demande d’une des Parties.
      </p>
      <p>
        <b>ARTICLE 22 – ELECTION DE DOMICILE</b>
      </p>
      <p>La Société élit domicile au 20, Rue du Petit Four – 51100 Reims (France).</p>
    </div>
  );
}

export default Policies;
